import { FC } from "react";

import { PageContextWrapper, TopHeaderCalendar } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";
import { RydeUiUnit } from "@ryde/shared";

const entity: RydeUiUnit = "rideProduction";

export const RideProductionsPage: FC = () => {
  return (
    <PageContextWrapper entity={entity}>
      <PageClientSideFilters
        topWidgetComponent={<TopHeaderCalendar entity={entity} />}
      />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
